import { render } from "./AllWorkSpaceUser.vue?vue&type=template&id=3d2c2aea&scoped=true"
import script from "./AllWorkSpaceUser.vue?vue&type=script&lang=js"
export * from "./AllWorkSpaceUser.vue?vue&type=script&lang=js"

import "./AllWorkSpaceUser.vue?vue&type=style&index=0&id=3d2c2aea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2c2aea"]])

export default __exports__